<template>
  <div class="page">
    <div
      class="contentDetail"
      :style="{ 'margin-bottom': showBottomBar ? '44px' : '0' }"
    >
      <div class="topLayout">
        <div class="title">{{ activityDetailData.title }}</div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="logo-info" v-if="$route.query.saleIid">
            <img :src="activityDetailData.salerImg" alt="" />
            <span>{{ activityDetailData.saler }}</span>
          </div>
          <div class="teamgo" v-if="activityDetailData.teamGo">
            <img src="./assets/teamgo.png" alt="" />
            小包团(<span
              v-for="(item, index) in activityDetailData.teamPersonNum"
              :key="index"
              >{{ (index != 0 ? "/" : "") + item.num }}人</span
            >)
          </div>
        </div>

        <div class="markWordsLayout">
          <div style="width: 100%">
            <p class="leftWordsLayout">
              <span class="tagMark" v-if="activityDetailData.province">{{
                activityDetailData.province
              }}</span>
              <span class="tagMark" v-if="activityDetailData.city">{{
                activityDetailData.city
              }}</span>
              <span v-if="activityDetailData && activityDetailData.tags">
                <span
                  class="tagMark"
                  v-for="(tag, index) in JSON.parse(activityDetailData.tags)"
                  :key="index"
                  >{{ tag }}</span
                >
              </span>
            </p>
            <p
              class="rightWordsLayout"
              v-if="activityDetailData && activityDetailData.views"
            >
              阅读{{ activityDetailData.views }}次
            </p>
          </div>
          <div
            class=""
            v-if="!!activityDetailData.destination"
            style="
              width: 100%;
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #666;
              margin-top: 5px;
              padding-left: 5px;
              box-sizing: border-box;
            "
          >
            <span style="flex-shrink: 0; max-width: 120px; line-height: 1">
              <img
                src="./assets/img/1.png"
                style="
                  width: 12px;
                  margin-right: 4px;
                  color: #c3c3c3;
                  font-size: 12px;
                "
                alt=""
              />
              行程天数：{{ activityDetailData.during }}天
            </span>

            <span
              style="
                flex-shrink: 0;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                align-items: center;
                flex: 1;
                line-height: 1;
              "
            >
              <img
                src="./assets/img/addr.png"
                style="
                  width: 8px;
                  margin-right: 4px;
                  color: #c3c3c3;
                  font-size: 12px;
                  margin-left: 10px;
                "
                alt=""
              />目的地：{{ activityDetailData.destination.detail }}
              <span
                v-if="activityDetailData.actType == 2"
                style="display: flex; align-items: center"
              >
                <img
                  src="./assets/img/menpiao1.png"
                  style="width: 15px; margin-left: 20px"
                />
                &nbsp; 门票
              </span>
            </span>
          </div>
        </div>
        <img class="poster" v-lazy="activityDetailData.image" />
      </div>
      <normal-editor
        v-if="activityDetailData && activityDetailData.content"
        :isInApp="isInApp"
        :editorContent="htmlDecode(activityDetailData.content)"
      ></normal-editor>
      <div class="botLayout" style="position: relative">
        <div class="litle-info" v-if="groupInfo.dateRange">
          <div class="title" style="color: #323031">
            <div
              style="
                color: #323031;
                font-size: 14px;
                font-weight: 500;
                background-image: linear-gradient(#fff, #6fce74);
                margin-bottom: 20px;
              "
            >
              线路排期
            </div>
          </div>
          <!-- <div class="item" v-for="(item,index) in groupInfo.dateRange" :key="index">
                  <div class="day" style="align-items: center;font-weight: 500;color:#777"> 
                      <div class="chengren" style="margin-left:10px;    display: inline;"><img src="./assets/img/yuan.jpg" alt="" style="width: 10px;height: 10px;margin-right: 5px;    margin-top: 6px;">{{item}} </div>
                     <div class="chengren" style="margin-left:10px;    display: inline;">成人：<span style="    text-decoration: underline">{{groupInfo.selectedObj[item].adult.normalPrice}}元/人</span> </div>
                     <div class="chengren" style="margin-left:10px;    display: inline;">儿童：<span style="    text-decoration: underline">{{groupInfo.selectedObj[item].child.normalPrice}}元/人</span></div>
                  </div>
                </div> -->
          <table
            class="list_table"
            style="width: 100%; border: 2px solid #6f6f6f"
            align="center"
          >
            <thead>
              <tr style="height: 35px">
                <th
                  style="
                    border: 1px solid #6f6f6f;
                    background: #f1f1f1;
                    padding-left: 5px;
                  "
                >
                  排期
                </th>
                <th
                  style="
                    border: 1px solid #6f6f6f;
                    background: #f1f1f1;
                    padding-left: 5px;
                  "
                >
                  成人价格
                </th>
                <th
                  style="
                    border: 1px solid #6f6f6f;
                    background: #f1f1f1;
                    padding-left: 5px;
                  "
                >
                  儿童价格
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in groupInfo.dateRange" :key="index">
                <td style="border: 1px solid #6f6f6f; padding-left: 5px">
                  {{ item }}
                </td>
                <td style="border: 1px solid #6f6f6f; padding-left: 5px">
                  {{ groupInfo.selectedObj[item].adult.normalPrice }}元/人
                </td>
                <td style="border: 1px solid #6f6f6f; padding-left: 5px">
                  {{ groupInfo.selectedObj[item].child.normalPrice }}元/人
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="activityDetailData" style="margin-bottom: 44px">
          <div style="width: 100%">
            <img
              src="./assets/img/chengxin.png"
              alt=""
              style="width: 100%; height: 100%"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBar" v-if="showBottomBar">
      <div class="functionButtonLayout">
        <yd-icon name="wentijieda" slot="icon" size=".3rem" custom></yd-icon>
        <button @click="contactCustomerActoin()">客服</button>
      </div>
      <div class="verticalLineLayout"></div>
      <div class="functionButtonLayout">
        <yd-icon
          name="icon_renwujincheng"
          slot="icon"
          size=".3rem"
          custom
        ></yd-icon>
        <button @click="seeErollListAction()">已报</button>
      </div>
      <div class="verticalLineLayout"></div>
      <div class="functionButtonLayout">
        <yd-icon name="kuaisubianpai" slot="icon" size=".3rem" custom></yd-icon>
        <button @click="shareFodderAction()">素材</button>
      </div>
      <div class="verticalLineLayout"></div>
      <div class="functionButtonLayout">
        <yd-icon name="fangkuai" slot="icon" size=".3rem" custom></yd-icon>
        <button @click="enrollActivityAction()">
          {{ activityDetailData.actType == 2 ? "购票" : "报名" }}
        </button>
      </div>
    </div>
    <div
      class="bottomBar"
      v-if="
        !showBottomBar &&
        this.$route.query.saleIid &&
        this.$route.query.saleIid != 1000
      "
    >
      <div class="functionButtonLayout" style="width: 50%">
        <yd-icon name="wentijieda" slot="icon" size=".3rem" custom></yd-icon>
        <button @click="contactCustomerActoin()">客服</button>
      </div>
      <div class="verticalLineLayout"></div>

      <div class="functionButtonLayout" style="width: 50%">
        <yd-icon name="fangkuai" slot="icon" size=".3rem" custom></yd-icon>
        <button @click="enrollActivityAction()">
          {{ activityDetailData.actType == 2 ? "购票" : "报名" }}
        </button>
      </div>
    </div>
    <div class="consult" v-if="showConsult">
      <!-- <div v-for="(consultor, index) in consults" :key="index">
                <div class="consultPerson" >
                    <img class="consultPortrait" :src="consultor.image">
                    <div class="consultIntroduce">{{consultor.name}}</div>
                    <a :href="'tel:'+consultor.phone">
                        <yd-icon name="phone2" size=".4rem" color="#008000"></yd-icon>
                    </a>
                </div>
                <div v-if="index<consults.length-1" style="background-color:#f1f1f1; height:1px"></div>
            </div> -->
      <div class="concust-box">
        <ul>
          <li v-for="(consultor, index) in consults" :key="index">
            <div class="left">
              <img
                :src="consultor.image"
                style="width: 100%; border-radius: 50%; height: 100%"
                alt=""
              />
            </div>
            <div class="right" style="flex: 1; display: flex">
              <div
                class="right-left"
                style="
                  flex: 1;
                  padding-left: 20px;
                  box-sizing: border-box;
                  height: 35px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                "
              >
                <div
                  class="name"
                  style="color: #333333; font-size: 14px; font-weight: 500"
                >
                  {{ consultor.name }}
                </div>
                <div class="phone" style="color: #3c3c3c; font-size: 12px">
                  {{ consultor.phone }}
                </div>
              </div>
              <div
                class="call"
                style="
                  width: 95px;
                  height: 35px;
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                "
              >
                <div
                  class="wechat"
                  v-if="consultor.qrCode"
                  @click="
                    wechatUrl = consultor.qrCode;
                    wechatUrlFlag = true;
                  "
                >
                  <img
                    style="width: 20px; height: 20px; margin-right: 20px"
                    src="./assets/img/wechat.png"
                    alt=""
                  />
                </div>
                <a :href="'tel:' + consultor.phone">
                  <img
                    style="width: 20px; height: 20px"
                    src="./assets/img/tel.png"
                    alt=""
                /></a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="showConsult"
      class="consult consult-cancel"
      @click="hiddenMaskAction()"
    >
      取消
    </div>

    <div
      class="maskLayout"
      @click="hiddenMaskAction()"
      v-if="showConsult"
    ></div>
    <yd-popup v-model="showCalendar" position="bottom" width="100%">
      <div style="background-color: #fff">
        <event-calendar
          @getDateInfoFromCalendar="getEnrollDateInfo"
          v-bind:actId="actId"
        >
        </event-calendar>
      </div>
    </yd-popup>

    <van-dialog v-model="wechatUrlFlag">
      <div
        class="wechat-dia"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <div
          class=""
          style="
            font-size: 16px;
            color: #000;
            height: 60px;
            font-weight: 500;
            line-height: 60px;
          "
        >
          添加客服
        </div>
        <img style="width: 150px; height: 150px" :src="wechatUrl" />
        <div
          class="tip"
          style="font-size: 12px; color: #333; height: 40px; line-height: 40px"
        >
          长按识别二维码
        </div>
      </div>
    </van-dialog>

    <div
      v-if="mine.permission && mine.permission > 0"
      class="shareBtn"
      style="
        position: fixed;
        z-index: 1000;
        right: 0px;
        top: 60%;
        transform: translateY(-50%);
        width: 90px;
      "
      v-clipboard:copy="shortUrl"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >
      <img src="./assets/img/share.png" alt="" style="width: 100%" />
    </div>
  </div>
</template>

<script>
import appService from "@/services/request/appService";
import wechatService from "@/services/request/wechatService";
import EventCalendar from "@/pages/common/EventCalendar";
import NormalEditor from "@/pages/common/NormalEditor";
import VueClipboard from "vue-clipboard2";
import Vue from "vue";
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
import store from "store";
import { timeout } from "q";
export default {
  name: "ActivityDetail",
  components: {
    EventCalendar,
    NormalEditor,
  },
  data() {
    return {
      mine: {},
      actId: this.$route.query.id,
      activityDetailData: {},
      showBottomBar: false,
      showConsult: false,
      consults: [],
      showCalendar: false,
      isInApp: false,
      groupInfo: [],
      shortUrl: "",
      wechatUrlFlag: false,
      wechatUrl: "",
    };
  },
  created() {
    if (this.$route.query.u) {
      store.set("loginData", "");
    }
  },
  mounted: function () {
    // alert(666)
    console.log(window.location.host);
    this.$nextTick(function () {
      // document.title = "线路"
      // this.mine = store.get('mine')
      if (!this.mine) {
        this.mine = {};
        this.mine.iid = this.$route.query.iid;
      }

      if (false) {
        this.showBottomBar = this.mine.permission > 0 ? true : false;
        this.loadData(() => {
          this.shareConfig();
        });
      } else {
        this.loadData(() => {
          this.mine.iid = this.$route.query.iid;

          this.wechatInit(() => {
            this.getUserPermissionScope(() => {
              this.showBottomBar = this.mine.permission > 0 ? true : false;
              this.shareConfig();
              this.creatShortUrl();
            });
          });
        });
      }
    });
  },
  methods: {
    onCopy: function (e) {
      alert("复制成功: " + e.text);
    },
    onError: function (e) {
      console.log(e);
      alert("复制失败");
    },
    creatShortUrl() {
      let url =
        "http://huaxiyou.cc" +
        "/m/a/d?id=" +
        this.$route.query.id +
        "&iid=" +
        this.$route.query.iid +
        "&u=" +
        this.mine.u;
      let desc =
        this.activityDetailData.title +
        " 行程:" +
        this.activityDetailData.during +
        "天 " +
        "集合地:" +
        this.activityDetailData.destination.detail;
      this.shortUrl = url;
      // return
      appService
        .createShortUrl({
          url: encodeURIComponent(url),
        })
        .then((data) => {
          this.shortUrl = desc + " - " + data;
          console.log(data);
        })
        .catch((error) => {
          var errorStr = "短链接生成失败";
          if (error && error.msg) {
            errorStr = error.msg;
          } else if (error && error.sub_msg) {
            errorStr = error.sub_msg;
          }
          this.$dialog.toast({
            mes: errorStr,
            timeout: 1500,
            icon: "error",
          });
        });
    },
    wechatInit(callback) {
      if (this.$page.isInWechat) {
        wechatService.auth(
          this.$route.query.iid ? this.$route.query.iid : this.mine.iid,
          ({ openid, unionid }) => {
            if (!!openid && !!unionid) {
              this.mine.unionId = unionid;
              this.mine.openId = openid;
            }
            if (typeof callback === "function") callback();
          },
          false
        );
      } else {
        if (typeof callback === "function") callback();
      }
    },
    getUserPermissionScope(callback) {
      if (true) {
        appService
          .getUserIdentity({
            iid: this.$route.query.iid ? this.$route.query.iid : this.mine.iid,
            rid: 0,
            unionId: store.get("loginData")
              ? store.get("loginData").id
              : this.mine.unionId,
            saleIid: this.$route.query.saleIid ? this.$route.query.saleIid : "",
          })
          .then(
            (data) => {
              if (data && data.permission) {
                var permissionInfo = data.permission;
                this.mine.permission = permissionInfo.op;
                this.mine.u = data.u;
              }
              if (typeof callback === "function") callback();
            },
            (error) => {
              var errorStr = "加载失败";
              if (error && error.msg) {
                errorStr = error.msg;
              } else if (error && error.sub_msg) {
                errorStr = error.sub_msg;
              }
              this.$dialog.toast({
                mes: errorStr,
                timeout: 1500,
                icon: "error",
              });
            }
          );
      } else {
        if (typeof callback === "function") callback();
      }
    },
    loadData(callback) {
      appService
        .getActivityDetail({
          id: this.actId,
          u: this.$route.query.u ? this.$route.query.u : "",
          saleIid: this.$route.query.saleIid ? this.$route.query.saleIid : "",
        })
        .then(
          (data) => {
            if (data) {
              data.destination = JSON.parse(data.destination);
              data.teamPersonNum = JSON.parse(data.teamPersonNum || "[]");

              this.activityDetailData = data;
              document.title = this.activityDetailData.title;
              var customerJson = data.customerInfos;
              if (customerJson) {
                this.consults = JSON.parse(customerJson);
              }
              let groupInfo = JSON.parse(data.groupInfo);
              this.groupInfo = groupInfo;
              store.set("activityDetailDataCache", data);
              if (typeof callback === "function") callback();
            }
          },
          (error) => {
            var errorStr = "加载失败";
            if (error && error.msg) {
              errorStr = error.msg;
            } else if (error && error.sub_msg) {
              errorStr = error.sub_msg;
            }
            this.$dialog.toast({
              mes: errorStr,
              timeout: 1500,
              icon: "error",
            });
          }
        );
    },
    contactCustomerActoin() {
      if (!this.consults.length) {
        this.$dialog.toast({
          mes: "当前线路暂无客服",
          timeout: 1500,
          icon: "error",
        });
        return;
      }
      this.showConsult = !this.showConsult;
    },
    seeErollListAction() {
      this.$router.push({
        path: "/m/activity/enrollers",
        query: {
          actId: this.actId,
          iid: this.$route.query.iid,
        },
      });
    },
    shareFodderAction() {
      this.$router.push({
        path: "/m/activity/fodder",
        query: {
          actId: this.actId,
          iid: this.activityDetailData.iid,
        },
      });
    },
    enrollActivityAction() {
      this.showCalendar = true;
    },
    getEnrollDateInfo(dateItem) {
      this.showCalendar = false;
      this.$router.push({
        path: "/m/activity/enroll",
        query: {
          date: dateItem.date,
          iid: this.$route.query.iid ? this.$route.query.iid : this.mine.iid,
          saleIid: this.$route.query.saleIid ? this.$route.query.saleIid : "",
        },
      });
    },
    hiddenMaskAction() {
      this.showConsult = false;
    },
    shareConfig() {
      setTimeout(() => {
        var shareUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/m/a/d?id=" +
          this.$route.query.id +
          "&iid=" +
          this.$route.query.iid +
          "&saleIid=" +
          (this.$route.query.saleIid ? this.$route.query.saleIid : "") +
          "&u=" +
          this.mine.u;
        var imageUrl = this.activityDetailData.image + "@.png";
        var desc =
          "行程天数 " +
          this.activityDetailData.during +
          "天," +
          "集合地 " +
          this.activityDetailData.destination.detail;
        this.wxShareConfig = {
          title: this.activityDetailData.title,
          desc: desc,
          imgUrl: imageUrl,
          link: shareUrl,
        };
        console.log("wxShareConfig", this.wxShareConfig);
        console.log("mine", this.mine);
        wechatService.jsapi(this.$route.query.iid, this.wxShareConfig, [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "chooseWXPay",
        ]);
      }, 100);
    },
  },
};
</script>

<style scoped lang="less">
.page {
  font-size: 0.28rem;
  background-color: white;
}
.contentDetail {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  padding-left: 3px;
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
  background-color: white;
  .botLayout {
    .litle-info {
      display: flex;
      flex-wrap: wrap;
      padding: 12px;
      .item {
        width: 100%;
        flex-shrink: 0;
        color: #373737;
        padding: 5px 0;
        font-size: 0.26rem;
      }
    }
  }
}
.contentDetail .topLayout {
  padding-left: 9px;
  padding-right: 12px;
}
.teamgo {
  padding: 0 15px;
  height: 22px;
  background: rgba(213, 213, 213, 0.43);
  border-radius: 11px;
  border: 1px solid #d5d5d5;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #787878;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  img {
    margin-right: 3px;
    width: 15px;
    height: 15px;
  }
}
.contentDetail .topLayout .logo-info {
  display: flex;
  align-items: center;
  padding-left: 5px;
  box-sizing: border-box;
  img {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }
  span {
    font-size: 12px;
    color: rgb(102, 102, 102);
    margin-left: 5px;
  }
}
.contentDetail .topLayout .title {
  width: 100%;
  font-size: 0.4rem;
  padding-top: 12px;
}
.contentDetail .topLayout .markWordsLayout {
  width: 100%;
  display: flex;
  margin-top: 8px;
  flex-wrap: wrap;
}
.contentDetail .topLayout .markWordsLayout .leftWordsLayout {
  float: left;
  width: calc(100% - 94px);
  padding-left: 5px;
  box-sizing: border-box;
}
.contentDetail .topLayout .markWordsLayout .rightWordsLayout {
  float: right;
  text-align: right;
  width: 90px;
  font-size: 0.24rem;
  color: #666;
  padding-top: 4px;
  box-sizing: border-box;
}
.tagMark {
  color: #61cb67;
  font-size: 0.26rem;
  padding-right: 4px;
}
.contentDetail .poster {
  margin-top: 12px;
  margin-bottom: 12px;
  width: 100%;
  height: calc((100% - 24px) * 2 / 3);
  border-radius: 4px;
  object-fit: cover;
  overflow: hidden;
}
.bottomBar {
  display: flex;
  position: absolute;
  width: 100%;
  left: 0px;
  right: 0px;
  height: 44px;
  bottom: 0;
  margin-right: 0;
  border-left-width: 0;
  border-bottom-width: 0;
  border-right-width: 0;
  border-top-width: 1px;
  border-top-color: #f5f5f5;
  border-style: solid;
  justify-content: space-between;
  background-color: white;
  z-index: 1000;
}
.bottomBar .functionButtonLayout {
  width: 25%;
  text-align: center;
  justify-content: center;
  vertical-align: middle;
  margin: auto 0;
}
.bottomBar .functionButtonLayout button {
  margin-left: 6px;
  font-size: 0.3rem;
  color: #666;
  text-align: center;
  border: none;
  z-index: 1000;
}
.bottomBar .verticalLineLayout {
  margin: auto;
  width: 1px;
  background-color: #eee;
  height: 22px;
}
.consult {
  position: absolute;
  background-color: white;
  z-index: 1000;
  bottom: 120px;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 10px;
  padding: 15px;
}
.consult-cancel {
  bottom: 60px;
  box-sizing: border-box;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #59d026;
}
.consult .concust-box ul li {
  display: flex;
  padding: 5px;
  box-sizing: border-box;
}
.consult .concust-box ul li .left {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  flex-shrink: 0;
}
.consult .consultPerson {
  width: 100%;
  background-color: white;
  display: flex;
  z-index: 1000;
}
.consult .consultPerson .consultPortrait {
  float: left;
  margin: 7px;
  margin-left: 5%;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: center;
  justify-content: center;
  object-fit: cover;
}
.consult .consultPerson .consultIntroduce {
  float: right;
  margin: auto 8px;
  height: 30px;
  line-height: 30px;
  font-size: 0.28rem;
  vertical-align: middle;
}
.consult .consultPerson a {
  margin-left: 50px;
  height: 44px;
  line-height: 44px;
}
.maskLayout {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 44px;
  background-color: #212121;
  opacity: 0.7;
  z-index: 500;
}
::-webkit-scrollbar {
  width: 3px !important;
  z-index: 1000;
  overflow: hidden;
}
.animation1 {
  animation-name: upmove;
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
  animation-delay: 0;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-direction: normal;
  -webkit-animation-name: upmove;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-delay: 0;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-direction: normal;
}
@keyframes upmove {
  0% {
    bottom: -44px;
    opacity: 0;
  }
  100% {
    bottom: 0px;
    opacity: 1;
  }
}
@-webkit-keyframes upmove /*Safari and Chrome*/ {
  0% {
    bottom: -44px;
    opacity: 0;
  }
  100% {
    bottom: 0px;
    opacity: 1;
  }
}
</style>

